import angular from 'angular';
import uiRouter from 'angular-ui-router';
import profilePageComponent from './profilePage.component';

let profilePageModule = angular.module('profilePage', [
  uiRouter
])

.component('profilePage', profilePageComponent)

.name;

export default profilePageModule;
